/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsibleRelative/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Contact from './Contact/index'
import React from 'react'
import Separator from './Separator/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ResponsibleRelative({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/ResponsibleRelatives/Content/ResponsibleRelative",
  triggerRef,
  toggleContact
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let responsibleRelativeFromPersonRecordFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'responsible_relative',
path: 'from_person_record.first_name',
})
let constantData = ' ('
let responsibleRelativeTypeValueData = fromData.useDataFormat({ viewPath,
context: 'responsible_relative',
path: 'type',
format: fromFormat.capitalize,
})
let constantData1 = ')'
let aggregateData = fromAggregate.joinNoSpace(responsibleRelativeFromPersonRecordFirstNameValueData, constantData, responsibleRelativeTypeValueData, constantData1)
  return (<React.Fragment
>
<Contact
  viewPath={`${viewPath}/Contact`}
 triggerRef={triggerRef}
/>
<button
  data-testid="ResponsibleRelative.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={toggleContact}
 ref={triggerRef}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textDecoration="underline dotted"
 className="text-decoration-skip-ink-none text-underline-offset-4"
 data="responsible_relative.from_person_record.first_name"
 data="' ('"
 data="responsible_relative.type"
 format="/Data/format.js capitalize"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
 className="text-decoration-skip-ink-none text-underline-offset-4"
/>
<Separator
  viewPath={`${viewPath}/Separator`}
/>
</button>
{children}
</React.Fragment>)
}